var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiscover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1585_97)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1699 8.00879C27.041 8.00879 27.5201 8.41174 27.5201 9.17287C27.5636 9.75491 27.1716 10.2474 26.649 10.337L27.8249 11.9935H26.9103L25.9086 10.3817H25.8215V11.9935H25.081V8.00879H26.1699ZM25.8213 9.8446H26.0391C26.5181 9.8446 26.7359 9.62073 26.7359 9.21778C26.7359 8.8596 26.5181 8.63574 26.0391 8.63574H25.8213V9.8446ZM22.5107 11.9935H24.6013V11.322H23.2512V10.2474H24.5578V9.57582H23.2512V8.68037H24.6013V8.00879H22.5107V11.9935ZM20.3336 10.6951L19.3318 8.00879H18.5478L20.1593 12.0831H20.5513L22.1628 8.00879H21.3789L20.3336 10.6951ZM11.4922 10.0236C11.4922 11.1429 12.3633 12.0831 13.4521 12.0831C13.8005 12.0831 14.1054 11.9936 14.4103 11.8593V10.9638C14.1925 11.2325 13.8876 11.4116 13.5392 11.4116C12.8424 11.4116 12.2762 10.8743 12.2762 10.1579V10.0684C12.2326 9.35201 12.7988 8.72519 13.4957 8.68042C13.8441 8.68042 14.1925 8.85951 14.4103 9.12815V8.2327C14.149 8.05361 13.8005 8.00884 13.4957 8.00884C12.3633 7.91929 11.4922 8.85951 11.4922 10.0236ZM10.142 9.53163C9.70641 9.35254 9.57576 9.26299 9.57576 9.03913C9.61931 8.7705 9.8371 8.54663 10.0984 8.59141C10.3162 8.59141 10.5339 8.72572 10.7082 8.90481L11.1001 8.36754C10.7953 8.09891 10.4033 7.91982 10.0113 7.91982C9.40156 7.87505 8.8789 8.36754 8.83534 8.99436V9.03913C8.83534 9.5764 9.05311 9.88981 9.75 10.1137C9.9242 10.1584 10.0984 10.248 10.2726 10.3375C10.4033 10.4271 10.4904 10.5614 10.4904 10.7405C10.4904 11.0539 10.2291 11.3225 9.9677 11.3225H9.9242C9.57576 11.3225 9.27088 11.0987 9.14022 10.7853L8.66113 11.2778C8.92245 11.7703 9.4451 12.0389 9.9677 12.0389C10.6646 12.0837 11.2308 11.5464 11.2744 10.83V10.6957C11.2308 10.1584 11.013 9.88981 10.142 9.53163ZM7.61523 11.9935H8.35565V8.00879H7.61523V11.9935ZM4.1748 8.00879H5.26365H5.48142C6.52671 8.05356 7.35424 8.94901 7.31068 10.0235C7.31068 10.6056 7.04936 11.1429 6.61382 11.5458C6.22183 11.8592 5.74274 12.0383 5.26365 11.9935H4.1748V8.00879ZM5.1328 11.3211C5.48124 11.3658 5.87322 11.2315 6.13454 11.0077C6.39587 10.739 6.52653 10.3808 6.52653 9.97788C6.52653 9.6197 6.39587 9.26152 6.13454 8.99288C5.87322 8.76902 5.48124 8.6347 5.1328 8.67947H4.91503V11.3211H5.1328Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6314 7.91699C15.5426 7.91699 14.6279 8.81244 14.6279 9.97652C14.6279 11.0958 15.499 12.0361 16.6314 12.0808C17.7638 12.1256 18.6349 11.1854 18.6784 10.0213C18.6349 8.85721 17.7638 7.91699 16.6314 7.91699Z",
    fill: "#FD6020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20.5L31.85 15V19C31.85 19.8284 31.1785 20.5 30.35 20.5H14Z",
    fill: "#FD6020"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 31.5,
    height: 19.5,
    rx: 1.75,
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1585_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscover);
export default __webpack_public_path__ + "static/media/discover.49125ce7bede082aa79cf81a719e1ae4.svg";
export { ForwardRef as ReactComponent };